import React from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector } from "react-redux";

import { CloseIcon, TrashIcon } from "@pages/casino/assets/icons";

import { IconContainer, Tag, TagContainer, TagsContainer } from "./elements.js";

const selectTranslate = (state) => ({
	translate: getTranslate(state.localize),
});

const Tags = ({ data, onRemoveTag, onRemoveAll, ...props }) => {
	const { translate } = useSelector(selectTranslate);

	const areValuesBoolean = data?.every(
		(tag) =>
			typeof tag.value === "boolean" || tag?.value === "all-games" || tag?.value === undefined
	);

	if (!data || data.length === 0 || !Array.isArray(data) || areValuesBoolean) {
		return null;
	}

	return (
		<TagsContainer {...props}>
			<IconContainer data-testid="button-filtered-casino-clear-all" onClick={onRemoveAll}>
				<TrashIcon fill="var(--main-color)" />
			</IconContainer>

			{data?.map((tag, index) => {
				return (
					<TagContainer
						key={tag.key}
						onClick={() => onRemoveTag?.(tag)}>
						<Tag data-testid={`text-filtered-casino-active-${tag.section}`} key={index}>
							{tag.section === "category" ||
							tag.section === "alphabetic" ||
							tag.section === "provider"
								? tag.value
								: translate("casino." + tag.value)}
						</Tag>
						<CloseIcon
							data-testid={`button-filtered-casino-clear-${tag.section}`}
							width={14}
							height={14}
							fill="var(--main-color)"
						/>
					</TagContainer>
				);
			})}
		</TagsContainer>
	);
};

export default Tags;
